let DB = [
    {
        title: 'Madame',
        source: './src/assets/projects/madame/01.png',
        description: '"The body is not a thing, it is a situation: it is our grasp on the world and our sketch of our project."',
        author: '- Simone de Beauvoir',
        images: [
            './src/assets/projects/madame/02.png', 
            './src/assets/projects/madame/03.png', 
            './src/assets/projects/madame/04.png'
        ],
        color: '#E5ADA0'
    },
    {
        title: 'Sunshine',
        source: './src/assets/projects/summer/01.png',
        description: '"You cannot live your life looking at yourself from someone else\'s point of view."',
        author: '- Penelope Cruz',
        images: [
            './src/assets/projects/summer/02.png', 
            './src/assets/projects/summer/03.png', 
            './src/assets/projects/summer/04.png'
        ],
        color: '#ECBA30'
    },
    {
        title: 'Queens',
        source: './src/assets/projects/queens/01.png',
        description: '"It has been women who have breathed gentleness and care into the hard progress of humankind."',
        author: '- Queen Elizabeth II',
        images: [
            './src/assets/projects/queens/02.png', 
            './src/assets/projects/queens/03.png', 
            './src/assets/projects/queens/04.png'
        ],
        color: '#4EA3B9'
    },
    {
        title: 'Manga',
        source: './src/assets/projects/manga/01.png',
        description: '"For most of us, art is supposed to do something more than simply mirror the confusions of the world."',
        author: '- Michiko Kakutani',
        images: [
            './src/assets/projects/manga/03.png', 
            './src/assets/projects/manga/02.png', 
            './src/assets/projects/manga/04.png'
        ],
        color: '#B52F3A'
    }
];

export default DB;


// WEBPACK FOOTER //
// ./src/database/Base.js